import { render, staticRenderFns } from "./_betListOXTOEMLDetails.vue?vue&type=template&id=079c068d&lang=pug&"
import script from "./_betListOXTOEMLDetails.vue?vue&type=script&lang=js&"
export * from "./_betListOXTOEMLDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports